"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormatMessage = exports.getFormattedMessage = void 0;
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
var getFormattedMessage = function (messageKey) {
    var messageId = messageKey || '';
    if (messageKey && messageKey !== '') {
        return react_1.default.createElement(react_intl_1.FormattedMessage, { id: messageId });
    }
    return '';
};
exports.getFormattedMessage = getFormattedMessage;
var getFormatMessage = function (messageKey, intl) {
    var tmpTexts = react_intl_1.defineMessages({
        dynamicLabel: {
            id: messageKey || 'notfound',
            defaultMessage: '',
        },
    });
    var message = intl.formatMessage(tmpTexts.dynamicLabel);
    return message;
};
exports.getFormatMessage = getFormatMessage;
var CustomMessages = react_intl_1.defineMessages({
    errorEmailApi: {
        id: 'errorEmailApi',
        defaultMessage: '',
    },
    errorEmailApiRecipientNotFound: {
        id: 'errorEmailApiRecipientNotFound',
        defaultMessage: '',
    },
    headline: {
        id: 'newsletter.unsubscribe.headline',
    },
});
exports.default = CustomMessages;
//# sourceMappingURL=messages.js.map